import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { Metric } from '../../interfaces/metric.interface';
import { StaticMetricMenuItem } from 'Angular/services/static-menus/interfaces/static-metric-menu.interface';

import { MetricByCategoryListDirective } from '../metric-by-category-list/metric-by-category-list.directive';
import { GetCategoryScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-scroll-id.pipe';
import { GetCategoryTopScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-category-top-scroll-id.pipe';
import { GetMetricScrollIdPipe } from 'CalculationsApp/ts/features/metric-selector-modal/pipes/get-metric-scroll-id.pipe';

/**
 * Single Metric By Category List
 *
 * Outputs:
 *   submitMetricHandler: An event emitter that emits a selected metric.
 *
 */
@Component({
    standalone: false,
    selector: 'ycn-single-metric-by-category-list',
    templateUrl: '../metric-by-category-list/metric-by-category-list.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleMetricByCategoryListComponent extends MetricByCategoryListDirective {
    @Input() selectedMetricName?: string;

    @Output() submitMetricHandler: EventEmitter<Metric> = new EventEmitter<Metric>();

    constructor(
        private changeDetector: ChangeDetectorRef,
        protected getCategoryScrollId: GetCategoryScrollIdPipe,
        protected getCategoryTopScrollId: GetCategoryTopScrollIdPipe,
        protected getMetricScrollId: GetMetricScrollIdPipe
    ) {
        super(getCategoryScrollId, getCategoryTopScrollId, getMetricScrollId);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    selectMetric(metric: StaticMetricMenuItem, ..._: any[]): void {
        // Notify the metric modal of the selected metric
        this.submitMetricHandler.emit(metric as Metric);
    }

    // Reset maps
    // Add check mark for and scroll to preselected metric
    reset(): void {
        super.reset();
        if (this.selectedMetricName && this.selectedMetricName in this.flatMetricsMap) {
            const metricInfo = this.getMetricInfo(this.selectedMetricName);
            this.addSelectedMetricToMaps(metricInfo);
            this.scrollToMetric(metricInfo);
        }
        this.changeDetector.markForCheck();
    }
}
